import React, { useContext } from 'react'
import FlexView from 'react-flexview/lib'
import { SUBSCRIPTION_STATE } from '../../../../models/insurance-models/PolicySubscriptionState'
import { PolicyRenewalContextStore } from '../../../../context/PolicyRenewalContext'
import { ModifyPolicySection } from '../ModifyPolicy/ModifyPolicySection'
import { ModificationContextStore } from '../../../../context/ModificationContext'
import { awaitWithLoading } from '../../../../services/utils'
import { SessionService } from '../../../../services/SessionService'

export const ModifyPolicyButton = ({ insurance }) => {
  const policyRenewalContext = React.useContext(PolicyRenewalContextStore)
  const [openModify, setOpenModify] = React.useState(false)
  const modificationContext = useContext(ModificationContextStore)
  const now = new Date()
  const differenceInHours =
    modificationContext.insurance.endPolicyDate != undefined
      ? (modificationContext.insurance.endPolicyDate.getTime() -
          now.getTime()) /
        (1000 * 60 * 60)
      : 24

  const openDialog = () => {
    setOpenModify(true)
  }

  const closeDialog = () => {
    modificationContext.getPolicyDetails()
    setOpenModify(false)
  }

  return (
    <FlexView hAlignContent="right">
      <FlexView>
        <span
          className="text-small blue bold underline clickable margin-left-big margin-top-basic margin-bottom-basic"
          onClick={() => openDialog()}>
          {policyRenewalContext.insuranceSubscriptionState ==
          SUBSCRIPTION_STATE.RENEWAL
            ? 'Edit Renewal'
            : 'Edit Policy Details'}
        </span>
      </FlexView>
      <ModifyPolicySection
        isOpen={openModify}
        insurance={insurance}
        closeDialog={() => closeDialog()}
        isRenewal={
          policyRenewalContext.insuranceSubscriptionState ==
          SUBSCRIPTION_STATE.RENEWAL
            ? true
            : false
        }
      />
    </FlexView>
  )
}
